/* eslint-disable @typescript-eslint/explicit-function-return-type */
import axios from "axios";
import { getAccessToken } from "../../lib/auth/accessToken";

export { getAccessToken };

const getAuthorizationHeader = (): string => {
  const accessToken = getAccessToken();
  return accessToken ? `Bearer ${accessToken}` : "Bearer";
};

const UNAUTHORIZED_ERROR_CODE = 401;

// const insightsURL = process.env.REACT_APP_INSIGHTS_API_URL ?? ""
const insightsURL = "https://qa.api.insights.cropwise.com";
const insightsVersion = process.env.REACT_APP_INSIGHTS_API_VERSION ?? "";
const insightsBaseURL = `${insightsURL}/${insightsVersion}`;
export const InsigtsAPIAxiosInstance = axios.create({
  baseURL: insightsBaseURL,
  headers: {
    "Cache-Control": "no-cache",
    Authorization: getAuthorizationHeader(),
  },
});

InsigtsAPIAxiosInstance.interceptors.request.use(
  function (config) {
    config.headers.Authorization = getAuthorizationHeader();
    return config;
  },
  async function (error) {
    return await Promise.reject(new Error(error));
  }
);
InsigtsAPIAxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === UNAUTHORIZED_ERROR_CODE) {
      //   authService.getAccessToken();
      // void logout();
    }
  }
);

export default InsigtsAPIAxiosInstance;
